import { Chip, withStyles } from "@material-ui/core";
import React from 'react';
import clsx from 'clsx';

const styles = theme => ({
    chip: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        boxShadow: '0 1px 1px 0 rgba(0, 0, 0, .7)',
        '&:hover, &:focus': {
            backgroundColor: theme.palette.primary.dark,
        }
    },
});

const Resposta = (props) => {
    const { enviar, data, classes } = props;

    return (
        <React.Fragment>
            <Chip
                label={data.interacao}
                onClick={() => enviar(`#${data.idmensagembotinteracao}#`)}
                className={clsx(classes.chip, "mr-8 mt-8")}
                key={`Resposta_${data.idmensagembotinteracao}`}
            />
        </React.Fragment>
    );
}


export default withStyles(styles, { withTheme: true })(Resposta);